var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-dusk":"single-policies"}},[_c('dd-header-card',{attrs:{"header":"Losse Polissen"}},[_c('dd-main-table',{attrs:{"rounded":true,"has-select":false,"headers":_vm.policyTableHeaders,"rows":_vm.policies}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }